import { EchantillonMouvementEdition } from './echantillon-mouvement-edition.model';
import { EchantillonOperateurEdition } from './echantillon-operateur-edition.model';
import { EchantillonSiteEdition } from './echantillon-site-edition.model';
import { OrganismeEdition } from './organisme-edition.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class EchantillonEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        numeroPassage: { key: 'numeroPassage', optional: true, default: '' },
        numero: { key: 'numero', optional: true, default: '' },
        millesime: { key: 'millesime', optional: true, default: '' },
        cahier: { key: 'cahier', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        mouvement: { key: 'mouvement', converter: new (ClassConverterFactory.build(EchantillonMouvementEdition))(), optional: true },
        operateur: { key: 'operateur', converter: new (ClassConverterFactory.build(EchantillonOperateurEdition))(), optional: true },
        site: { key: 'site', converter: new (ClassConverterFactory.build(EchantillonSiteEdition))(), optional: true },
        organisme: { key: 'organisme', converter: new (ClassConverterFactory.build(OrganismeEdition))(), optional: true }
    };

    id: number;
    numeroPassage: string;
    numero: string;
    millesime: string;
    cahier: string;
    produit: string;
    mouvement: EchantillonMouvementEdition;
    operateur: EchantillonOperateurEdition;
    site: EchantillonSiteEdition;
    organisme: OrganismeEdition;
}
